export default __webpack_public_path__ + "static/media/help.76bdfca1.svg";